import urlUtils from '@/utils/url.utils';
import Vue from 'vue';

Vue.use({
  install() {
    Vue.prototype.$generateAssetsUrl = function (url: string): URL {
      return urlUtils.generateAssetsUrl(url);
    };

    Vue.prototype.$generateWidgetUrl = function (url: string): URL {
      return urlUtils.generateWidgetUrl(url);
    };
  },
});
